import PageClean from '../../../assets/images/layout-builder/straight.png'

export const PageCleanIcon = () => {
  return <img src={PageClean} alt='PageLocked' width='25px' height='25px' />
}
